import React, { useState, useRef, useCallback, useEffect } from "react";
import * as XLSX from 'xlsx';
import { MuiMaterials } from '../../@index.js';
import * as global from '../../data/global';
import { outlinedActionButtonSx } from '../../components/windowChrome/index.js';

const Upload = ({ accept, context, isExcel, excelData, setExcelData }) => {
    const [image, setImage] = useState("");
    const [forceUpdate, setForceUpdate] = useState(0);

    const inputFile = useRef(null);

    // Helper function to get theme-aware colors (reads directly from global.gw.theme)
    const getThemeColor = useCallback((lightColor, darkColor) => {
        if (global.gw.theme === 'light') {
            return lightColor;
        }
        return darkColor;
    }, []);

    // Listen for theme changes - only trigger re-render when theme actually changes
    useEffect(() => {
        const handleThemeChange = () => {
            setForceUpdate(prev => prev + 1);
        };
        window.addEventListener('themeChanged', handleThemeChange);
        return () => window.removeEventListener('themeChanged', handleThemeChange);
    }, []);

    const handleFileUpload = e => {
        //const { files } = e.target;
        //for (var i = 0; i < files.length; i++) {
        //    let file = files[i];
        //    const reader = new FileReader();
        //    reader.addEventListener("load", () => {
        //        grainWave.jsonFiles.push({ fileName: file.name, fileContents: reader.result });
        //    }, false);
        //    if (file) {
        //        reader.readAsText(files[0]);
        //    }
        //}
    };

    const handleExcelFileChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const binaryString = event.target.result;
            const workbook = XLSX.read(binaryString, { type: 'binary' });
            let allSheetData = [];
            for (var i = 0; i < workbook.SheetNames.length; i++) {
                const sheetName = workbook.SheetNames[i];
                const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                allSheetData.push(sheetData);
            }
            setExcelData(allSheetData);
        };
        reader.readAsBinaryString(file);
    };

    const onClick = () => {
        inputFile.current.click();
    };

    return (
        <div>
            <input
                style={{ display: "none" }}
                ref={inputFile}
                onChange={(e) =>
                {
                    if (isExcel) {
                        handleExcelFileChange(e);
                    }
                    else {
                        handleFileUpload();
                    }
                }}
                type="file"
                accept={accept}
            />
            <MuiMaterials.Button
                key={`upload-button-${global.gw.theme}-${forceUpdate}`}
                className="button"
                size="small"
                variant="outlined"
                sx={{
                    width: "100%",
                    ...outlinedActionButtonSx(),
                }}
                onClick={onClick}
            >
                {!context ? "Select File" : context}
            </MuiMaterials.Button>
        </div>
    );
};

export default Upload;



//export const Upload = () => {
//    const handleFileUploadError = (error) => {
//        // Do something...
//        var testerror = "";
//        testerror = "";
//    }

//    const handleFilesChange = (files) => {
//        for (var i = 0; i < files.length; i++) {
//            let file = files[i];
//            const reader = new FileReader();
//            reader.addEventListener("load", () => {
//                grainWave.jsonFiles.push({ fileName: file.name, fileContents: reader.result });
//            }, false);
//            if (file) {
//                reader.readAsText(files[0]);
//            }
//        }
//    }
//    console.log('grainWave.jsonFiles', grainWave.jsonFiles);

//    return (
//        <FileUpload
//            getBase64={false}
//            multiFile={false}
//            disabled={false}
//            header=""
//            leftLabel=""
//            rightLabel=""
//            buttonLabel="Upload"
//            buttonRemoveLabel="Remove all"
//            maxFileSize={10}
//            maxUploadFiles={0}
//            maxFilesContainerHeight={357}
//            acceptedType={'json/*'}
//            errorSizeMessage={'fill it or remove it to use the default error message'}
//            allowedExtensions={['json']}
//            onFilesChange={handleFilesChange}
//            onError={handleFileUploadError}
//            BannerProps={{ elevation: 0, variant: "outlined" }}
//            onContextReady={context => {
//                let pnode = document.querySelector('#root');

//                let testhere = "";
//            }}
//        />
//    )
//};

//export default Upload;











//import React, { useState, useRef } from "react";

//const Upload = () => {
//    const [image, setImage] = useState("");
//    const inputFile = useRef(null);

//    const handleFileUpload = e => {
//       // var file = inputFile.files[0];
//       // var textType = /json.*/;

//       // //if (file.type.match(textType)) {
//       //     var reader = new FileReader();

//       //     reader.onload = function (e) {
//       //         var content = reader.result;
//       //         //Here the content has been read successfuly
//       //         console.log(content);
//       //     }

//       //     reader.readAsText(file);
//       ////}



//        //const { files } = e.target;
//        //if (files && files.length) {
//        //    const filename = files[0].name;

//        //    var parts = filename.split(".");
//        //    const fileType = parts[parts.length - 1];
//        //    console.log("fileType", fileType); //ex: zip, rar, jpg, svg etc.

//        //    //var file = new File([""], filename, { type: "application/json" });
//        //    var file = files[0];
//        //    //or const file = document.querySelector('input[type=file]').files[0];
//        //    const reader = new FileReader();

//        //    reader.onload = function (e) {

//        //        // This is done just for the proof of concept
//        //        var binaryString = e.target.result;
//        //        var base64 = btoa(binaryString);
//        //        var blobfile = atob(base64);


//        //        window.blobFromBlobFile = b64toBlob(base64, MIMEType, 512);
//        //        window.blobURL = URL.createObjectURL(window.blobFromBlobFile);


//        //        if (MIMEType != "image/jpeg") {
//        //            var a = "<br /><a href=\"" + window.blobURL + "\">Blob File Link</a>";
//        //        } else {
//        //            var a = "<img src=" + window.blobURL + "\>";
//        //        }

//        //        document.getElementById('byte_content').innerHTML = a;
//        //        console.log(a);
//        //    };


//        //    //reader.onload = function (e) {
//        //    //    const blob = new Blob([new Uint8Array(e.target.result)], { type: file.type });




//        //    //    console.log(blob);
//        //    //};
//        //    //reader.readAsText(file);
//        //    reader.readAsArrayBuffer(file);




//            ////setImage(files[0]);

//            ////var file = files[0];
//            ////console.log(file);
//            ////// var textType = /text.*/;

//            //////if (file.type.match(textType)) {
//            //var reader = new FileReader();

//            //reader.onload = function (e) {
//            //    var content = reader.result;
//            //    //Here the content has been read successfuly
//            //    console.log(content);
//            //}

//            //reader.readAsDataURL(image);
//            //// }
//       // }
//    };

//    function b64toBlob(b64Data, contentType, sliceSize) {
//        contentType = contentType || '';
//        sliceSize = sliceSize || 512;

//        var byteCharacters = atob(b64Data);
//        var byteArrays = [];

//        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
//            var slice = byteCharacters.slice(offset, offset + sliceSize);

//            var byteNumbers = new Array(slice.length);
//            for (var i = 0; i < slice.length; i++) {
//                byteNumbers[i] = slice.charCodeAt(i);
//            }

//            var byteArray = new Uint8Array(byteNumbers);

//            byteArrays.push(byteArray);
//        }

//        var blob = new Blob(byteArrays, { type: contentType });
//        return blob;
//    }

//    const onClick = () => {
//        inputFile.current.click();
//    };

//    //console.log("imageimage", image);
//    return (
//        <div>
//            <input
//                style={{ display: "none" }}
//                // accept=".zip,.rar"
//                ref={inputFile}
//                onChange={handleFileUpload}
//                type="file"
//            />
//            <button className="button" onClick={onClick} style={{ fontSize: 'inherit' }}>
//                Upload
//            </button>
//        </div>
//    );
//};

//export default Upload;